export const SET_HEADER_LOGO = 'src/components/Header/featuredContentOrSku/SET_HEADER_LOGO';
